import { get } from 'lodash';
import { InitialState } from '../types/hubTypes';

export const gethubUpcomingSessionsPage = (state: InitialState) => {
  return get(state, 'ui.apiState.hubUpcomingSessionsPage');
}